import React from 'react';

type PrimaryActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidth?: boolean;
};

const PrimaryActionButton: React.FC<PrimaryActionButtonProps> = ({
  children,
  className = '',
  fullWidth = false,
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={`inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-amber-300 to-orange-500 px-5 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-[#2b1209] shadow-[0_14px_32px_rgba(201,126,23,0.24)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_40px_rgba(201,126,23,0.34)] disabled:cursor-not-allowed disabled:opacity-50 ${fullWidth ? 'w-full' : ''} ${className}`.trim()}
    {...props}
  >
    {children}
  </button>
);

export default PrimaryActionButton;

